import UpdateMachineInfoMain from "./UpdateMachineInfoMain";

function UpdateMachineInfo() {
  return (
    <>
      <UpdateMachineInfoMain />
    </>
  );
}

export default UpdateMachineInfo;
